import _ from "lodash";
import { ReferentialImage } from "../types/ContentfulTypes";

export const getReferentialImageIndex = (props: {
  referentialImages?: ReferentialImage[];
  configuration: any;
}): number | undefined => {
  const { referentialImages, configuration } = props;

  const referentialImageIndex = referentialImages?.findIndex(referentialImage => {
    const populatedSelections = {
      ...(configuration || {}),
    };
    const populatedReferentialImage = {
      ...(configuration || {}),
      ...(referentialImage.selections || {}),
    };

    return _.isEqual(populatedReferentialImage, populatedSelections);
  });

  return referentialImageIndex;
};

export const getStudioDocumentUrl = (): string | undefined => {
  if (typeof window === "undefined") {
    return;
  }
  const url = new URLSearchParams(window.location.search);
  return encodeURIComponent(url.get("documentUri") || "");
};

export const getTemplateId = (): string | undefined => {
  if (typeof window === "undefined") {
    return;
  }
  const url = new URLSearchParams(window.location.search);
  return encodeURIComponent(url.get("quickView") || "");
};

export const isTemplateFeatureFlag = (): boolean => {
  try {
    if (typeof window === "undefined") {
      return false;
    }
    const url = new URLSearchParams(window.location.search);
    const isTemplateEnabled = encodeURIComponent(url.get("isTemplateEnable") || "");
    return isTemplateEnabled === "true";
  } catch (e) {
    return false;
  }
};
